import { useSelector } from 'react-redux';
import { AppState } from 'services/redux-store';

import { BiddingState, biddingStateSelectors } from '../bidding-state.slice';

export const useGetBiddingState = (refNum: string): BiddingState => {
    return useSelector((state: AppState) => biddingStateSelectors.selectById(state, refNum) || ({} as BiddingState));
};
